import React from "react";
import { useTranslation } from 'react-i18next';
import { useSelector } from "react-redux";

import game_w from "../../img/menu_left/game_white.svg";
import game_g from "../../img/menu_left/game.svg";
import faq_w from "../../img/menu_left/faq_white-01.svg";
import faq_g from "../../img/menu_left/faq_green-01.svg";
import supp_w from "../../img/menu_left/support_white.svg";
import supp_g from "../../img/menu_left/support_green.svg";
import rocket from "../../img/menu_left/rocket_white-01.svg";

const Siredar = props => {
    const { t } = useTranslation("navigation");
  const noImg = name => {
    let sub = name.substring(0, 1);
    return sub.toUpperCase();
  };

  return (
    <div className="sidebar">
      <div className="sidebar_header">
        {props.photoURL !== null ? (
          <div className="sidebar_header_img" style={{ backgroundImage: `url(${props.photoURL})` }}></div>
        ) : (
          <div className="sidebar_header_img img_container_mobile_NO_IMG">
            <div>{noImg(props.bloggerData.name)}</div>
          </div>
        )}
        <p>{props.bloggerName}</p>
      </div>
      <span className="sidebar_underline" />
      <div className={props.menu === "game" ? "sidebar_button sidebar_button_selected" : "sidebar_button"} onClick={() => props.setMenuItem("game")}>
        <img src={props.menu === "game" ? game_w : game_g} alt="" />
        <span>{ t("Условия игры") }</span>
      </div>
      <div className={props.menu === "faq" ? "sidebar_button sidebar_button_selected" : "sidebar_button"} onClick={() => props.setMenuItem("faq")}>
        <img src={props.menu === "faq" ? faq_w : faq_g} alt="" />
        <span>{ t("Вопросы и ответы (FAQ)") }</span>
      </div>
      {props.bloggerData.isSupportEnabled === 1 && props.bloggerData.showLink === 1 ? (
        <div
          className={props.menu === "support" ? "sidebar_button sidebar_button_selected" : "sidebar_button"}
          onClick={() => props.setMenuItem("support")}
        >
          <img src={props.menu === "support" ? supp_w : supp_g} alt="" />
          <span>{ t("Техподдержка") }</span>
        </div>
      ) : null}

      {props.bloggerData.showLink === 1 ? (
        <a style={{ textDecoration: "none" }} href={`${window.location.origin}/${props.bloggerData.link}`} target="_blank" rel="noopener noreferrer">
          <div className="sidebar_button sidebar_add_service">
            <img src={rocket} alt="" />
            <span>{ t("Подключить сервис") }</span>
          </div>
        </a>
      ) : null}
    </div>
  );
};

export default Siredar;
